module.exports = __webpack_public_path__ + "img/purple-square-table-4.87bf85de.png";